// components
import FormContainer from "../../components/Login/FormContainer/FormContainer";
// constants
import { WHITE_THEME } from "../../constants/logo";
// images
import Logo from "../../components/ui/Logo/Logo";

const Login = () => {
  return (
    <div className="flex">
      <div className="relative z-10 w-full lg:w-3/4 h-screen">
        <FormContainer />
      </div>
      <div className="bg-dark-blue relative w-1/4 hidden lg:block">
        <div className="w-fit mx-auto mt-6">
          <Logo theme={WHITE_THEME} />
        </div>
        <div className="absolute bottom-4 right-0 w-500 h-80 bg-mechanic-car bg-no-repeat bg-right bg-contain" />
      </div>
    </div>
  );
};

export default Login;
